import React from "react";
import { useNavigate } from "react-router-dom";

export default function RootModelHeader({ hideHeader,navigateTo='/home', setAddonCloseCallback }) {
  const navigate = useNavigate();
  const handelModelClose = () => {
    navigate(navigateTo);
    if(setAddonCloseCallback){
      setAddonCloseCallback();
    }
  };
  return (
    <div className="root-model-header">
      <div className="model-close-btn" onClick={handelModelClose}>
        <i className="fas fa-times"></i>
      </div>
      

        <div className="root-model-header-useless-div "></div>

    </div>
  );
}
